import { Component } from '@angular/core';
import GlobalComponent from '../global-component';

@Component({
  selector: 'app-health',
  imports: [
    // RouterOutlet,
  ],
  standalone: true,
  template: 'OK.<br>Version: {{ APP_VERSION }}<br>Build: {{ APP_TIMESTAMP }}',
})
export class HealthComponent {
  protected readonly APP_VERSION = GlobalComponent.APP_VERSION;
  protected readonly APP_TIMESTAMP = GlobalComponent.APP_TIMESTAMP;
}
